import PoweredBy from './PoweredBy';

export default PoweredBy;
